import {
  mixinDialogActions,
  mixinDialogGetters,
  mixinDialogMutations
} from "@/mixins/vuexDialogs";
import { getField, updateField } from "vuex-map-fields";

export default {
  namespaced: true,

  state: {
    tokens: [],
    totalTokens: 0,
    loading: {
      mainTable: false
    },
    options: {
      page: 1,
      itemsPerPage: 25,
      sortBy: ['created_at'],
      sortDesc: [true],
      groupBy: [],
      groupDesc: [],
      mustSort: false,
      multiSort: false
    },
  },

  getters: {
    ...mixinDialogGetters,
    getField,

    tokens: state => state.tokens,
    totalTokens: state => state.totalTokens,
    loading: state => state.loading,
  },

  mutations: {
    ...mixinDialogMutations,
    updateField,

    SET_TOKENS: (state, payload) => {
      if (Array.isArray(payload)) {
        state.tokens = payload
      } else {
        state.tokens = []
      }
    },

    SET_TOTAL_TOKENS: (state, payload) => {
      state.totalTokens = payload
    },

    SET_LOADING: (state, payload) => {
      state.loading[payload.key] = payload.value
    },
  },

  actions: {
    ...mixinDialogActions,

    async loadTokens ({ state, commit, dispatch }, payload) {
      try {
        commit('SET_LOADING', { key: 'mainTable', value: true })
        let request = '/personal-access-tokens?'
        const { sortBy, sortDesc, page, itemsPerPage } = state.options

        if (payload && payload.page) {
          request += `page=${payload.page}&`
        } else if (page !== undefined) {
          request += `page=${page}&`
        }

        if (payload && payload.itemsPerPage) {
          request += `perPage=${payload.itemsPerPage}&`
        } else if (itemsPerPage !== undefined) {
          request += `perPage=${itemsPerPage}&`
        }

        if (payload && payload.sortBy) {
          request += `sortBy=${payload.sortBy}&`
        } else if (sortBy !== undefined && sortBy.length) {
          request += `sortBy=${sortBy[0]}&`
        }

        if (payload && payload.order) {
          request += `order=${payload.order}&`
        } else if (sortDesc !== undefined && sortDesc.length) {
          request += `order=${sortDesc[0] ? 'desc' : 'asc'}&`
        }

        if (request.endsWith('&')) {
          request = request.slice(0, request.length - 1)
        }

        const { status, data } = await this._vm.api.get(request)

        if (status === 200) {
          commit('SET_TOKENS', data.data)
          commit('SET_TOTAL_TOKENS', data.meta.total)
        }
      } catch (error) {
        // do not nothing
      } finally {
        commit('SET_LOADING', { key: 'mainTable', value: false })
      }
    },
  }
}
